import type { PromptBoxMentionInsert } from "src/base-components/Chat/PromptBox/PromptBox";

export type CaseCopilotFieldRefContext = {
  label: string;
  formKind: "task" | "action";
  formKey: string;
  fieldKey: string;
};

/** PromptBox mention for a form field. Serializes to a `<reference .../>`
 * tag in the sent message, like any other mention. */
export const buildFieldReferenceMention = (
  ref: CaseCopilotFieldRefContext,
): PromptBoxMentionInsert => ({
  value: ref.label,
  data: {
    id: `${ref.formKey}.${ref.fieldKey}`,
    kind: "field",
    form_kind: ref.formKind,
    form_key: ref.formKey,
    field_key: ref.fieldKey,
    variant: "gray",
  },
});
